module.exports = __webpack_public_path__ + "img/buy_super_cn.ef68c0e5.png";